import { render } from "./teacherchaxun.vue?vue&type=template&id=35472468&scoped=true"
import script from "./teacherchaxun.vue?vue&type=script&lang=js"
export * from "./teacherchaxun.vue?vue&type=script&lang=js"

import "./teacherchaxun.vue?vue&type=style&index=0&id=35472468&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-35472468"

export default script